import { IconButton } from "@mui/material"
import { ChevronLeftOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface BackButtonProps {
  onClick: () => void
  "aria-label": string
  "data-testid"?: string
}

export const BackButton: FC<BackButtonProps> = ({ onClick, "aria-label": ariaLabel, "data-testid": dataTestId }) => (
  <IconButton
    aria-label={ariaLabel}
    onClick={onClick}
    className='rounded bg-gray-200 text-primary'
    data-testid={dataTestId}
  >
    <ChevronLeftOutlined />
  </IconButton>
)
